import { SvgIconProps } from '@mui/material';
import Zizzi25thBirthdayImage from 'assets/images/zizzi-25th-birthday-promo.png';

interface Zizzi25thBirthdayProps extends SvgIconProps {
  width?: string;
  height?: string;
}

const Zizzi25thBirthdayCircle = ({ height = '96', width = '106' }: Zizzi25thBirthdayProps) => (
  <img
    width={width}
    height={height}
    src={Zizzi25thBirthdayImage}
    alt="Get 25 off for our 25th birthday!"
  />
);

export default Zizzi25thBirthdayCircle;
